import { Link } from 'react-router-dom';
import { featuredCollections, movies } from '@/mocks/movies';

export default function FeatureSection() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100" aria-label="特色专题">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950">
            <i className="ri-star-line text-accent-500 mr-2"></i>
            特色专题
          </h2>
          <p className="mt-2 text-sm text-foreground-500">精心挑选的观影专题，发现更多好内容</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {featuredCollections.map((collection) => {
            const collectionMovies = collection.movieIds
              .map((id) => movies.find((m) => m.id === id))
              .filter(Boolean);

            return (
              <Link
                key={collection.id}
                to={`/category/movie`}
                className="group relative rounded-2xl overflow-hidden h-56 md:h-64 cursor-pointer"
              >
                <img
                  src={collection.image}
                  alt={collection.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                  <h3 className="text-lg md:text-xl font-heading font-bold text-white mb-1">
                    {collection.title}
                  </h3>
                  <p className="text-sm text-white/70 mb-3">{collection.description}</p>
                  <div className="flex items-center gap-2">
                    {collectionMovies.map((m) => (
                      <span key={m?.id} className="px-2 py-1 text-xs bg-white/20 backdrop-blur-sm text-white rounded-md">
                        {m?.title}
                      </span>
                    ))}
                  </div>
                </div>
              </Link>
            );
          })}
        </div>

        <div className="mt-8 md:mt-10 grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-5 text-center">
          {[
            { icon: 'ri-movie-2-line', label: '海量资源', value: '100,000+', desc: '电影电视剧' },
            { icon: 'ri-4k-line', label: '高清画质', value: '4K', desc: '超清体验' },
            { icon: 'ri-speed-up-line', label: '极速播放', value: '秒开', desc: '无需缓冲' },
            { icon: 'ri-user-smile-line', label: '全免费', value: '0元', desc: '无需付费' },
          ].map((stat) => (
            <div key={stat.label} className="p-4 md:p-5 bg-background-50 border border-background-200/70 rounded-xl">
              <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-full bg-accent-50 text-accent-500 mb-3">
                <i className={`${stat.icon} text-lg`}></i>
              </div>
              <div className="text-xl md:text-2xl font-heading font-bold text-accent-500">{stat.value}</div>
              <div className="text-sm font-medium text-foreground-700 mt-1">{stat.label}</div>
              <div className="text-xs text-foreground-500">{stat.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}